const normalizeGrades = (grades) =>
  Object.keys(grades).reduce(
    (allGrades, key) => ({
      ...allGrades,
      // the response contains an array with only one object
      // {
      //   assignment1: [{ ...gradeFields }],
      //   assignment2: [{ ...gradeFields }],
      //   assignment3: [{ ...gradeFields }],
      // }
      // so we get the object out
      [key]: grades[key][0],
    }),
    {}
  );

export default normalizeGrades;
